(function () {
  if (window.kkProductCardsReady) return;
  window.kkProductCardsReady = true;
  async function addItem(form, button, buy) {
    if (!form || form.dataset.busy === 'true' || !form.reportValidity()) return;
    var card = form.closest('.product-card');
    var status = form.querySelector('.product-card__status');
    var original = button.textContent;
    var buttons = Array.from(form.querySelectorAll('button'));
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    form.dataset.busy = 'true';
    buttons.forEach(function (item) { item.disabled = true; });
    button.textContent = buy ? card.dataset.opening : card.dataset.adding;
    if (status) status.textContent = '';
    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || card.dataset.error);
      if (buy) {
        window.location.assign(root + 'checkout');
        return;
      }
      if (status) status.textContent = card.dataset.added;
      try {
        var cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
        if (cartResponse.ok) {
          var cart = await cartResponse.json();
          document.querySelectorAll('.cart-pill').forEach(function (link) {
            link.textContent = (link.dataset.cartLabel || 'Cart') + ' · ' + cart.item_count;
          });
        }
      } catch (ignored) {}
    } catch (error) {
      if (status) status.textContent = error.message || card.dataset.error;
    } finally {
      form.dataset.busy = 'false';
      button.textContent = original;
      buttons.forEach(function (item) { item.disabled = false; });
    }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.product-card__form')) return;
    var button = event.submitter || form.querySelector('.product-card__add');
    if (!button) return;
    event.preventDefault();
    addItem(form, button, false);
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('.product-card__buy');
    if (!button) return;
    event.preventDefault();
    addItem(button.closest('form'), button, true);
  });
})();
